const initialState = {
  notifications: [],
  readNotifications: [],
  unreadCount: 0,
  totalNotifications: 0,
  loading: false,
  error: null,
  userData: null,
  scheduleNotificationSuccess: false,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_NOTIFICATIONS_REQUEST":
    case "FETCH_READ_NOTIFICATIONS_REQUEST":
    case "GET_USER_REQUEST":
    case "SCHEDULE_NOTIFICATION_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        notifications: action.payload?.data || action.payload?.notifications || [],
        unreadCount:
          action.payload?.unreadCount ??
          action.payload?.total ??
          action.payload?.count ??
          0,
        totalNotifications:
          action.payload?.totalNotifications ??
          action.payload?.total ??
          0,
        error: null,
      };

    case "FETCH_READ_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        readNotifications: action.payload?.data || action.payload?.notifications || [],
        error: null,
      };

    case "FETCH_NOTIFICATIONS_FAIL":
    case "FETCH_READ_NOTIFICATIONS_FAIL":
    case "GET_USER_FAILURE":
    case "SCHEDULE_NOTIFICATION_SEND_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "MARK_NOTIFICATIONS_READ_SUCCESS":
      return {
        ...state,
        unreadCount: 0,
        notifications: state.notifications.map((item) => ({
          ...item,
          is_read: true,
        })),
      };

    case "MARK_NOTIFICATIONS_READ_FAIL":
      return {
        ...state,
        error: "Failed to mark read",
      };

    case "UPDATE_UNREAD_COUNT":
      return {
        ...state,
        unreadCount: action.payload,
      };

    case "GET_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      };

    case "SCHEDULE_NOTIFICATION_SEND_SUCCESS":
      return {
        ...state,
        loading: false,
        scheduleNotificationSuccess: true,
        error: null,
      };

    default:
      return state;
  }
};